import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';

const Section = styled.div`
  padding: 32px 0 8px 0;
  border-top: 1px solid var(--color-smoke-30);

  &:first-child {
    margin-top: 32px;
  }

  &:last-of-type {
    margin-bottom: 0;
    border-bottom: 1px solid var(--color-smoke-30);
  }

  &.loading {
    opacity: 0.5;
  }
`;

export const RepaymentSection: React.FC<any> = ({ children, field, isLoading }) => {
  /* {
  field: RepaymentStrategyField;
  isLoading: any;
} */
  return <Section className={cx({ loading: isLoading(field) })}>{children}</Section>;
};
